import { NotifyToWorkspaceResponse, TeamsResponse, UserPermissionResponse } from 'modules/User/workspace.types';
import request from 'utils/request';

/**
 * Fetcher to get the workspace teams list
 * @returns {TeamsResponse}
 */
export const getTeams = async () => {
  return await request<TeamsResponse>(`/workspace/teams`, {
    method: 'GET',
  });
};

/**
 * Fetcher to get the enterprise user permission list
 * @returns {TeamsResponse}
 */
export const getUserPermissions = async () => {
  return await request<UserPermissionResponse>(`/workspace/getUserPermission`, {
    method: 'GET',
  });
};

/**
 * Notify message to the team members
 * @param e1InfographId {string}
 * @param message {string}
 * @param groupIds {string[]}
 * @returns {NotifyToWorkspaceResponse}
 */
export const notifyToWorkspace = async (e1InfographId: string, message: string, groupIds: string[]) => {
  const groups = groupIds.map((id) => ({ id, type: 'team' }));
  const formData = new URLSearchParams();
  formData.append('multipage', '1');
  formData.append('message', message);
  formData.append('from', 'Editor');
  formData.append('groupsToNotify', JSON.stringify(groups));
  return await request<NotifyToWorkspaceResponse>(`/share/notifyworkspace/${e1InfographId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData,
  });
};
